import { Box } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import XIcon from "./x.svg?react";

export const BoxWithX: React.FC = () => {
  const parentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(88);

  useEffect(() => {
    if (parentRef.current) {
      setTimeout(() => {
        const parentHeight = parentRef.current?.getBoundingClientRect().height || 100;
        setHeight(parentHeight);
      }, 0);
    }
  }, []);

  return (
    <Box ref={parentRef} sx={{ width: "100%", height: height }}>
      <XIcon />
    </Box>
  );
};
